import { Trans } from 'react-i18next';

import {
   Form,
   IconFillColor,
   IconSize,
   IconWrapper,
   QuestionmarkCircleIcon,
   StyledFlex,
   Toggle,
   Tooltip,
} from '@dreryk/react-components';
import { useFormController } from '@dreryk/react-common';

import { patientPhoneNotificationTranslationKeys } from '../../../translations';
import { PhoneNotificationTooltipText } from '../PhoneNotificationTooltipText';

import { PatientPhoneNotificationVideoConsultationReminderToggleFormBean } from './PatientPhoneNotificationVideoConsultationReminderToggle.types';
import { useVideoConsultationReminderNotificationCommand } from './PatientPhoneNotificationVideoConsultationReminderToggle.hooks';

const t = patientPhoneNotificationTranslationKeys.notificationToggle;

type PatientPhoneNotificationVideoConsultationReminderToggleProps = {
   notificationEnabled: boolean;
   messages: string[];
};

export const PatientPhoneNotificationVideoConsultationReminderToggle = (
   props: PatientPhoneNotificationVideoConsultationReminderToggleProps
): JSX.Element => {
   const {
      executeAsync: enableVideoConsultationReminder,
      loading: enableVideoConsultationReminderLoading,
   } = useVideoConsultationReminderNotificationCommand();

   const {
      register,
      handleSubmit,
   } = useFormController<PatientPhoneNotificationVideoConsultationReminderToggleFormBean>({
      notificationEnabled: props.notificationEnabled,
   });

   return (
      <StyledFlex gap={'12px'} alignItems={'center'}>
         <Form onInput={handleSubmit(enableVideoConsultationReminder)}>
            <Toggle
               controller={register('notificationEnabled')}
               testId={'patientPhoneNotificationVideoConsultationReminderToggle'}
               disabled={enableVideoConsultationReminderLoading}
            />
         </Form>
         <StyledFlex gap={'4px'}>
            <Trans i18nKey={t.videoConsultationReminderToggle} />
            <Tooltip
               maxWidth={'400px'}
               testId={'patientPhoneNotificationVideoConsultationReminderToggleTooltip'}
               content={
                  <PhoneNotificationTooltipText
                     header={t.videoConsultationReminderToggleTooltip}
                     messages={props.messages}
                  />
               }
            >
               <IconWrapper
                  testId={'patientPhoneNotificationVideoConsultationReminderToggleTooltipIconWrapper'}
                  fillColor={IconFillColor.PRIMARY}
                  size={IconSize.SMALL}
               >
                  <QuestionmarkCircleIcon />
               </IconWrapper>
            </Tooltip>
         </StyledFlex>
      </StyledFlex>
   );
};
